export default "__VITE_ASSET__68dd1c98__"